import { createStore } from '@stencil/store';

export const Store = createStore({
  messageData: {
    contact_type: null,
    service_slug: null,
    // sub_category: null,
    subject: null,
    description: null,
    current_url: window.location.href,
    user_agent: navigator.userAgent,
    lang: null,
    conversation_uuid: null,
    priority: null,
    email: null,
    drive_os: null,
    drive_app_version: null,
    swiss_backup_storage: null,
    swiss_backup_product: null,
    swiss_backup_slot_cloud: null,
    swiss_backup_acronis_device: null,
    public_cloud_product: null,
    public_cloud_project: null,
    partner_account: null,
    public_cloud_region: null,
    public_cloud_service: null,
    public_cloud_service_info: null,
  },
  channel_id: null,
  bot_id: null,
  contactEventData: {
    enabled: false,
    opening: 'mail',
    contact_type: {
      value: null,
      disabled: false,
    },
    service_slug: {
      value: null,
      disabled: false,
    },
    email: {
      value: null,
      disabled: false,
    },
    sub_category: {
      value: null,
      disabled: false,
    },
    subject: {
      value: null,
      placeholder: null,
      disabled: false,
    },
    description: {
      value: null,
      placeholder: null,
      disabled: false,
    },
    partner_account: {
      value: null,
      disabled: false,
    },
  },
  is_full: false,
  is_report_abuse: false,
  is_report_abuse_sent: false,
  routing: [],
  onError: false,
  hasScroll: false,
  userAvatar: {
    name: null,
    url: null,
  },
  beepAvatar: {
    name: null,
    url: null,
  },
  isMobile: false,
  is_active: false,
  displayModal: false,
  typeModal: null,
  loaderResetConversation: false,
  g_recaptcha_response: null,
  visibilityModal: false,
  contactCode: null,
  isOpenFaqTrigger: false,
  isFromLanding: true,
  isInPartnership: false,
  supportPremium: {
    id: null,
    supportLevel: null,
    vipCode: null,
  },
  currentGroup: null,
  currentTicketId: null,
});
